/**
 * Welcome page entry.
 *
 * `public/index.html` was a standalone static page served at `/`. The chat SPA
 * mounts under the `/lungchat` basename, so the welcome page keeps its own
 * build entry rather than becoming a router route.
 */
import React from 'react';
import ReactDOM from 'react-dom/client';

import { WelcomePage } from '@/lungchat/pages/Welcome';

// Matches the inline script at `public/index.html:11-35`: apply the dark class
// before first paint and follow the system unless the user has chosen a theme.
const applyTheme = () => {
  const stored = localStorage.getItem('theme');
  const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
  document.documentElement.classList.toggle(
    'dark',
    stored === 'dark' || (!stored && prefersDark)
  );
};

applyTheme();
window
  .matchMedia('(prefers-color-scheme: dark)')
  .addEventListener('change', (event) => {
    if (localStorage.getItem('theme')) return;
    document.documentElement.classList.toggle('dark', event.matches);
  });

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <WelcomePage />
  </React.StrictMode>
);
